import React from 'react';

const SvgComponent = props => (
  <svg width={33} height={34} viewBox="0 0 33 34" fill="none" {...props}>
    <path
      d="M16.1992 4.28711V29.59"
      stroke="#2F6ECD"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8506 16.9395L3.54766 16.9395"
      stroke="#2F6ECD"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
